export type TaskDateValue = string | number | Date | null | undefined

const UNIX_SECONDS_MAX = 99_999_999_999

export function parseTaskDate(value: TaskDateValue): Date | null {
    if (value == null || value === '') {
        return null
    }

    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) || value.getTime() <= 0 ? null : value
    }

    const numericValue = typeof value === 'number'
        ? value
        : /^\d+(?:\.\d+)?$/.test(value.trim())
            ? Number(value)
            : null

    if (numericValue !== null) {
        if (!Number.isFinite(numericValue) || numericValue <= 0) {
            return null
        }

        // Some task endpoints return Unix time in seconds, while Date expects milliseconds.
        const timestamp = numericValue <= UNIX_SECONDS_MAX
            ? numericValue * 1000
            : numericValue
        const date = new Date(timestamp)

        return Number.isNaN(date.getTime()) ? null : date
    }

    const date = new Date(value)

    return Number.isNaN(date.getTime()) || date.getTime() <= 0 ? null : date
}

export function normalizeTaskDate(value: TaskDateValue, fallback?: Date): string | null {
    const date = parseTaskDate(value) || fallback || null

    return date ? date.toISOString() : null
}

export function formatTaskDate(value: TaskDateValue): string {
    const date = parseTaskDate(value)

    if (!date) {
        return '-'
    }

    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = String(date.getFullYear()).slice(-2)

    return `${day}/${month}/${year}`
}

export function formatTaskDateTime(value: TaskDateValue): string {
    const date = parseTaskDate(value)

    if (!date) {
        return '-'
    }

    const time = date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
    })

    return `${formatTaskDate(date)}, ${time}`
}
